/* ============
 * Routes File
 * ============
 *
 * The routes and redirects are defined in this file.
 */


/**
 * The routes
 *
 * @type {object} The routes
 */
export default [
  // Home
  {
    path: '/home',
    name: 'home.index',
    component: require('@/pages/home/index/index.vue'),

    // If the user needs to be authenticated to view this page
    meta: {
      auth: true,
    },
  },

// Order
  {
    path: '/order',
    component: require('@/pages/order/index.vue'),
    meta: {
      prettyName: 'order.order',
    },
    children: [
      {
        path: 'create',
        name: 'order.create',
        component: require('@/pages/order/create/index.vue'),
        meta: {
          auth: true,
          prettyName: 'order.orderCreate',
        },
      },
      {
        path: 'view',
        name: 'order.view',
        component: require('@/pages/order/view/index.vue'),
        meta: {
          auth: true,
          prettyName: 'order.view',
        },
      },
      {
        path: 'edit/:id',
        name: 'order.edit',
        props: true,
        component: require('@/pages/order/edit/index.vue'),
        meta: {
          auth: true,
          prettyName: 'order.edit',
        },
      },
    ],
  },

  // Product
  {
    path: '/product',
    component: require('@/pages/product/index.vue'),
    meta: {
      prettyName: 'product.product',
    },
    children: [
      {
        path: 'view',
        name: 'product.view',
        component: require('@/pages/product/view/index.vue'),
        meta: {
          auth: true,
          prettyName: 'base.view',
        },
      },
      {
        path: 'new',
        name: 'product.new',
        component: require('@/pages/product/new/index.vue'),
        meta: {
          auth: true,
          prettyName: 'base.new',
        },
      },
      {
        path: 'edit/:id',
        name: 'product.edit',
        component: require('@/pages/product/edit/index.vue'),
        props: true,
        meta: {
          auth: true,
          prettyName: 'base.edit',
        },
      },
    ],
  },

  // Wordboard
  {
    path: '/wordboard',
    name: 'wordboard.index',
    component: require('@/pages/wordboard/index.vue'),
    meta: {
      auth: true,
      prettyName: 'base.wordboard',
    },
  },

  // Customer
  {
    path: '/customer',
    component: require('@/pages/customer/index.vue'),
    meta: {
      prettyName: 'customer.customer',
    },
    children: [
      {
        path: 'view',
        name: 'customer.view',
        component: require('@/pages/customer/view/index.vue'),
        meta: {
          auth: true,
          prettyName: 'base.view',
        },
      },
      {
        path: 'edit/:id',
        name: 'customer.edit',
        component: require('@/pages/customer/edit/index.vue'),
        props: true,
        meta: {
          auth: true,
          prettyName: 'base.edit',
        },
      },
      {
        path: '/customer/group',
        name: 'customer.group',
        component: require('@/pages/customer/group/index.vue'),
        meta: {
          auth: true,
          prettyName: 'customer.group',
        },
      },
    ],
  },

  // User
  {
    path: '/user',
    component: require('@/pages/user/index.vue'),
    meta: {
      prettyName: 'user.user',
    },
    children: [
      {
        path: 'view',
        name: 'user.view',
        component: require('@/pages/user/view/index.vue'),
        meta: {
          auth: true,
          prettyName: 'base.view',
        },
      },
      {
        path: 'new',
        name: 'user.new',
        component: require('@/pages/user/new/index.vue'),
        meta: {
          auth: true,
          prettyName: 'base.new',
        },
      },
      {
        path: 'edit/:id',
        name: 'user.edit',
        component: require('@/pages/user/edit/index.vue'),
        props: true,
        meta: {
          auth: true,
          prettyName: 'base.edit',
        },
      },
    ],
  },

  // Login
  {
    path: '/login',
    name: 'login.index',
    component: require('@/pages/user/login/index/index.vue'),
    meta: {
      guest: true,
    },
  },

  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/*',
    redirect: '/home',
  },
];



// WEBPACK FOOTER //
// ./src/routes/index.js